module.exports = __webpack_public_path__ + "img/90.c191e93d.svg";